<div class="lp-container">
  <mat-select
    [ngModel]="currentLanguage$ | async"
    (ngModelChange)="translationService.setLanguage($event)"
  >
    <mat-option value="de">{{ "german" | translate }}</mat-option>
    <mat-option value="en">{{ "english" | translate }}</mat-option>
    <mat-option value="es">{{ "spanish" | translate }}</mat-option>
    <mat-option value="fr">{{ "french" | translate }}</mat-option>
    <mat-option value="it">{{ "italian" | translate }}</mat-option>
    <mat-option value="nl">{{ "dutch" | translate }}</mat-option>
  </mat-select>
</div>
